import { BENEFITS, BEFORE_AFTER } from "../../utils/constants";
import BenefitsTemplate from "./BenefitsTemplate";

export default function Benefits() {
  return <BenefitsTemplate benefits={BENEFITS} beforeAfter={BEFORE_AFTER} />;
}
